import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "paper-review"
};
var _hoisted_2 = {
  key: 1,
  class: "paper-body"
};
var _hoisted_3 = {
  class: "paper-list"
};
import { reactive, ref, computed } from 'vue';
import { getPrepareList } from '@/api/index-gai';
import { MessagePlugin } from 'tdesign-vue-next';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
import PracticeItem from './PracticeItem.vue';
import PracticeDialog from './PracticeDialog.vue';
export default {
  __name: 'Review',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var emptyImg = require('@/assets/noData.png');
    var _storeToRefs = storeToRefs(useUserStore()),
      userInfo = _storeToRefs.userInfo;
    var sizeOptions = [20, 50, 100, 200, 500];
    var pagination = reactive({
      current: 1,
      size: 10,
      total: 0
    });
    var resourceList = ref([]);
    var visible = ref(false);
    var practiceData = ref(null);
    var isLoading = ref(true);
    var isEmpty = computed(function () {
      return !isLoading.value && resourceList.value.length === 0;
    });

    /**
     * 刷新列表
     * @param {number} size 每页条数
     */
    var refresh = function refresh(size) {
      if (size) pagination.size = size;
      getPracticeList(size ? 1 : pagination.current);
    };
    // 获取习练列表
    var getPracticeList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(current) {
        var userId, res, _res$data, code, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              pagination.current = current;
              resourceList.value = [];
              isLoading.value = true;
              _context.p = 1;
              userId = userInfo.value.id;
              _context.n = 2;
              return getPrepareList(userId, _objectSpread({}, pagination));
            case 2:
              res = _context.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0 && data) {
                resourceList.value = data.records || [];
                pagination.total = data.total || 0;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error(_t.massage || '获取习练列表失败');
            case 4:
              _context.p = 4;
              isLoading.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function getPracticeList(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * 打开习练详情弹框
     * @param {object} item 习练数据
     */
    var changeItem = function changeItem(item) {
      var userId = userInfo.value.id;
      practiceData.value = _objectSpread(_objectSpread({}, item), {}, {
        userId: userId
      });
      visible.value = true;
    };
    __expose({
      refresh: refresh
    });
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      var _component_empty = _resolveComponent("empty");
      var _component_t_pagination = _resolveComponent("t-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_component_Loading, {
        class: "p-c"
      }, null, 512), [[_vShow, isLoading.value]]), isEmpty.value ? (_openBlock(), _createBlock(_component_empty, {
        key: 0,
        class: "p-c",
        icon: _unref(emptyImg)
      }, null, 8, ["icon"])) : _createCommentVNode("", true), !isEmpty.value && !isLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resourceList.value, function (item) {
        return _openBlock(), _createBlock(PracticeItem, {
          key: item.id,
          item: item,
          onChange: function onChange($event) {
            return changeItem(item);
          }
        }, null, 8, ["item", "onChange"]);
      }), 128))]), _createVNode(_component_t_pagination, {
        current: pagination.current,
        "onUpdate:current": _cache[0] || (_cache[0] = function ($event) {
          return pagination.current = $event;
        }),
        total: pagination.total,
        "page-size": pagination.size,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = function ($event) {
          return pagination.size = $event;
        }),
        "show-jumper": "",
        "show-sizer": true,
        "show-total": true,
        "page-size-options": sizeOptions,
        onCurrentChange: getPracticeList,
        onPageSizeChange: refresh
      }, null, 8, ["current", "total", "page-size"])])) : _createCommentVNode("", true), _createVNode(PracticeDialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return visible.value = $event;
        }),
        item: practiceData.value,
        onRefresh: refresh
      }, null, 8, ["visible", "item"])]);
    };
  }
};